import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import { SnackbarProvider } from 'notistack';

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import { theme } from './styles/theme';
import { AuthProvider } from './contexts/AuthContext';
import { AtendimentoNotificationProvider } from './contexts/AtendimentoNotificationContext';
import { SocketProvider } from './contexts/SocketContext';
import { logEnvVars, validateEnv } from '@/utils/env';
import 'react-toastify/dist/ReactToastify.css';

// Validar e logar variáveis de ambiente
validateEnv();
logEnvVars();

// Configuração do React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true, // Alterado para true para melhor atualização
      staleTime: 0, // Alterado para 0 para sempre considerar dados como desatualizados
      gcTime: 0, // Sempre considerar dados como frescos
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchInterval: 60000, // Refetch a cada 1 minuto globalmente
      refetchIntervalInBackground: true,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <HelmetProvider>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            dense
            preventDuplicate
          >
            <AuthProvider>
              <SocketProvider>
                <AtendimentoNotificationProvider>
                  <App />
                  <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                </AtendimentoNotificationProvider>
              </SocketProvider>
            </AuthProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </HelmetProvider>
); 